module.exports = __webpack_public_path__ + "img/firefox-2.3c703d2c.webp";